import { toast } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { useDeleteStudentGroup, useStudentGroupsQuery } from "../api/queries";
import { StudentGroupsFilter } from "../ui/student-groups/StudentGroupsFilter";
import { StudentGroupsTable } from "../ui/student-groups/StudentGroupsTable";
import { StudentGroupsToolbar } from "../ui/student-groups/StudentGroupsToolbar";

export function StudentGroupsPage() {
  const nav = useNavigate({ from: "/app/master/student-groups" });
  const search: OffsetPageQueryDTO = useSearch({
    from: "/app/master/student-groups",
  });

  const list = useStudentGroupsQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  const canManage = useActionPermission(["master:create"]);
  const deleteStudentGroup = useDeleteStudentGroup();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ກຸ່ມນັກຮຽນ" },
          ]}
        />
      </Header>

      <Main>
        <StudentGroupsToolbar
          canManage={!!canManage}
          onCreate={() => nav({ to: "/app/master/student-groups/create" })}
        />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <StudentGroupsFilter />

          <StudentGroupsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            sortBy={search.sort ? search.sort[0]?.field : undefined}
            sortOrder={
              search.sort ? (search.sort[0]?.dir as "asc" | "desc") : undefined
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onEdit={(group) =>
              nav({
                to: "/app/master/student-groups/$id/edit",
                params: { id: group.id },
              })
            }
            onDelete={async (id) =>
              toast.promise(deleteStudentGroup.run(id), {
                loading: "ກຳລັງລຶບ...",
                success: "ລຶບກຸ່ມນັກຮຽນສຳເລັດ",
                error: "ລຶບກຸ່ມນັກຮຽນລົ້ມເຫຼວ",
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
